<ng-template #backButtonRef>
  <img
    src="/assets/svg/ico-hamburger-close.svg"
    class="cross-button pointer-cursor float-right"
    (click)="closeDialog()"
  />
</ng-template>

<div
  class="access-point-building-container multi-user-selection-list-main position-relative"
>
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <!-- dynamic back button render -->
      <ng-content select="[backButton]"></ng-content>
    </div>
    <div>
      <p class="build-user-group mt-2 ml-3 text-center">
        {{ 'USER_ADD_USERS' | translate }}
      </p>
    </div>

    <div class="col-1">
      <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
    </div>
  </div>
  <div class="mt-4 row justify-content-center">
    <div class="col-8">
      <h1 class="text-center heading1">
        {{ 'ASSIGN_USERS' | translate }}
      </h1>
    </div>
  </div>

  <ng-container>
    <ng-container *ngIf="usersCopy?.length >= 1">
      <div class="row justify-content-between mt-3">
        <app-search-field
          (searchCriteria)="searchUsers($event)"
          class="col-10"
        ></app-search-field>
        <span class="position-relative">
          <img
            class="col-auto ml-3 filter-icon"
            src="assets/svg/ico-filter-circle-outline-white.svg"
            (click)="selectFilter()"
          />
          <span class="mf-badge" *ngIf="filterCount !== 0">
            <span class="circle-content">
              {{ filterCount || "" }}
            </span>
          </span>
        </span>
      </div>

      <div
        class="form-group row form-container slide-toggle-primary first mb-1"
      >
        <div class="row offset-8 col-10 pt-7 justify-content-end">
          {{ 'SELECT_ALL' | translate }}
        </div>
        <div
          class="col-2 text-right"
          (keyup.enter)="submit()"
          (keydown)="$event.preventDefault()"
        >
          <mat-slide-toggle
            class="mat-toggle"
            color="primary"
            [(ngModel)]="markAll"
            (change)="markList()"
          >
          </mat-slide-toggle>
        </div>
      </div>

      <div class="row user-list-container justify-content-center w-100">
        <ng-container *ngIf="!searchKeyPress && users as userList">
          <ng-container *ngIf="users.length < 1">
            <div class="d-flex flex-column align-items-center h-100">
              <div
                class="text-container d-flex flex-column justify-content-center align-items-center"
              >
                <div class="icon-container">
                  <img src="assets/svg/ico-user.svg" class="user-icon mt-4" />
                </div>
                <div class="text-center mt-3">
                  <p class="empty-box">{{ 'NO_USER_IN_THIS_SITE' | translate }}</p>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>

    <form
      (keyup.enter)="submit()"
      (keydown)="$event.preventDefault()"
      novalidate
    >
      <div class="listing unit-list unit-list-height mb-4">
        <span class="selected-floorName"> </span>
        <div class="scroll-container mt-3">
          <div class="overflow-y">
            <ng-container *ngFor="let user of users; let i = index">
              <ng-container *ngIf="!user?.isDeactivated">
              <div class="col-11 pl-2" *ngIf="checkIfNew(user?.name)">
                <div class="heading mb-1 mt-2">
                  {{ user?.name?.charAt(0).toUpperCase() }}
                </div>
              </div>

              <div
                class="form-group rounded-top form-container pr-2"
                [attr.data-userId]="user?.userId"
                [class.disabled-div]="user.alreadySelected"
              >
                <mat-form-field
                  appearance="fill"
                  class="w-100 building-list-container primary-input bottom-zero padding-top-balance middle"
                >
                  <div class="d-flex list-box full">
                    <span>
                      <app-profile-picture
                        [name]="user?.name"
                        [userData]="user"
                      >
                      </app-profile-picture>
                    </span>
                    <span
                      class="bold col-8 ml-3 d-flex justify-content-start align-items-center overflow-ellipsis"
                    >
                      <app-with-tooltip
                        class="overflow-ellipsis"
                        [showHelpCursor]="true"
                        >{{ user?.name }}</app-with-tooltip
                      >
                    </span>
                    <span class="selected-value-container checked-spacer col-2">
                      <span class="selected-value time-right"> </span>
                      <span class="btn-not-text">
                        <button
                          class="icon-button-checked"
                          type="button"
                          (click)="updateUserStatus(user)"
                        >
                          <img
                            class="icon mt-2"
                            [src]="
                              user.status
                                ? '/assets/svg/ico-checkmark-circle-outline.svg'
                                : '/assets/svg/ico-circle.svg'
                            "
                          />
                        </button>
                      </span>
                    </span>
                  </div>
                </mat-form-field>
              </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 my-1">
          <button
            class="btn btn-danger px-3 w-100 btn-submit"
            (click)="submit()"
            [disabled]="!validateUser && isDashboard"
          >
            {{ 'CONTINUE' | translate }}
          </button>
        </div>
      </div>
    </form>
  </ng-container>
</div>
